import { render, staticRenderFns } from "./Tagging.vue?vue&type=template&id=1e33f66e&scoped=true&"
import script from "./Tagging.vue?vue&type=script&lang=ts&"
export * from "./Tagging.vue?vue&type=script&lang=ts&"
import style0 from "./Tagging.vue?vue&type=style&index=0&id=1e33f66e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e33f66e",
  null
  
)

export default component.exports